import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';

export default function NavItem({
  icon: Icon,
  label,
  to,
  collapsed = false,
  nested = false,
  end = false,
  badge = null,
  onClick,
}) {
  return (
    <NavLink
      to={to}
      end={end}
      onClick={onClick}
      className={({ isActive }) =>
        cn(
          'group relative mt-0.5 flex items-center gap-3 rounded-lg text-sm font-medium transition-colors duration-150',
          collapsed ? 'justify-center px-2 py-2.5' : 'px-3 py-2',
          nested && !collapsed && 'pl-10',
          isActive
            ? 'bg-accent text-accent-foreground'
            : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
        )
      }
    >
      {({ isActive }) => (
        <>
          {isActive && !collapsed && (
            <span className="absolute left-0 top-1/2 h-5 w-[3px] -translate-y-1/2 rounded-r-full bg-primary" aria-hidden="true" />
          )}
          {Icon && <Icon className={cn('flex-shrink-0', collapsed ? 'w-5 h-5' : 'w-4 h-4')} aria-hidden="true" />}
          {!collapsed && <span className="flex-1 truncate">{label}</span>}
          {!collapsed && badge != null && (
            <span className="ml-auto rounded-full bg-primary/15 px-2 py-0.5 text-xs font-semibold text-accent-foreground">
              {badge}
            </span>
          )}
          {collapsed && (
            <span className="pointer-events-none absolute left-full z-50 ml-2 whitespace-nowrap rounded-md border border-border bg-popover px-2 py-1 text-xs text-popover-foreground opacity-0 shadow-lg transition-opacity group-hover:opacity-100">
              {label}
            </span>
          )}
        </>
      )}
    </NavLink>
  );
}
